export const scienceQuestions = [
  {
    id: 'science-001',
    category: 'Science',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'What is the chemical symbol for water?',
    options: ['H2O', 'CO2', 'O2', 'NaCl'],
    answer: 'H2O',
    insight: 'Water is made of two hydrogen atoms and one oxygen atom.',
    tags: ['chemistry', 'water', 'science'],
    points: 10,
  },
  {
    id: 'science-002',
    category: 'Science',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which planet is known as the Red Planet?',
    options: ['Mars', 'Venus', 'Jupiter', 'Mercury'],
    answer: 'Mars',
    insight: 'Mars looks red because of iron oxide dust on its surface.',
    tags: ['space', 'planets', 'mars'],
    points: 10,
  },
  {
    id: 'science-003',
    category: 'Science',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'Light travels faster than sound.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Light travels much faster than sound in air.',
    tags: ['physics', 'light', 'sound'],
    points: 10,
  },
  {
    id: 'science-004',
    category: 'Science',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which gas do plants primarily absorb for photosynthesis?',
    options: ['Oxygen', 'Carbon Dioxide', 'Nitrogen', 'Hydrogen'],
    answer: 'Carbon Dioxide',
    insight: 'Plants use carbon dioxide, water, and sunlight to make food.',
    tags: ['biology', 'plants', 'photosynthesis'],
    points: 20,
  },
  {
    id: 'science-005',
    category: 'Science',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which element has the chemical symbol O?',
    options: ['Oxygen', 'Gold', 'Osmium', 'Oxide'],
    answer: 'Oxygen',
    insight: 'Oxygen makes up about 21 percent of Earth atmosphere.',
    tags: ['chemistry', 'elements', 'oxygen'],
    points: 20,
  },
  {
    id: 'science-006',
    category: 'Science',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'The human body has four lungs.',
    options: ['True', 'False'],
    answer: 'False',
    insight: 'Humans have two lungs.',
    tags: ['biology', 'human body', 'anatomy'],
    points: 20,
  },
  {
    id: 'science-007',
    category: 'Science',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which metal is liquid at room temperature?',
    options: ['Mercury', 'Lead', 'Sodium', 'Silver'],
    answer: 'Mercury',
    insight: 'Mercury stays liquid at typical room temperatures.',
    tags: ['chemistry', 'metals', 'mercury'],
    points: 20,
  },
  {
    id: 'science-008',
    category: 'Science',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'What part of the cell contains most of its genetic material?',
    options: ['Nucleus', 'Ribosome', 'Mitochondrion', 'Cell wall'],
    answer: 'Nucleus',
    insight: 'The nucleus stores most DNA in eukaryotic cells.',
    tags: ['biology', 'cells', 'dna'],
    points: 30,
  },
  {
    id: 'science-009',
    category: 'Science',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'What is the pH value of a neutral solution at room temperature?',
    options: ['0', '7', '10', '14'],
    answer: '7',
    insight: 'A neutral solution has a pH of about 7.',
    tags: ['chemistry', 'ph', 'acids'],
    points: 30,
  },
  {
    id: 'science-010',
    category: 'Science',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'Electrons have a negative electric charge.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Electrons are negatively charged subatomic particles.',
    tags: ['physics', 'atoms', 'electricity'],
    points: 30,
  },
];
